import React from 'react';
import { Button } from 'antd-mobile';
import { RouteComponentProps } from 'react-router';
import { checkLogin } from '../../service/post';
import { delAllCookie } from '../../service/utils';

interface State {
  result: string;
}

type Props = RouteComponentProps;

export class TestCookie extends React.PureComponent<Props, State> {
  constructor(p: Props) {
    super(p);
    this.state = { result: '' };
  }

  handleTest = () => {
    this.setState({ result: document.cookie  });
  };

  login = () => {
    checkLogin().then();
  }
  deleteCookie = () => {
    delAllCookie();
    this.setState({ result: document.cookie });
  };

  toLive = () => {
    // https://signin.gsteps.live/web/live/912011
    this.props.history.push('/live/912011');
  }

  render() {
    return (
      <div style={{ padding: 16 }}>
        <h2 style={{ marginBottom: 16 }}>Cookie 测试ONLINE</h2>
        <p style={{ marginBottom: 12, color: '#666', fontSize: 14 }}>
          点击按钮会设置 <code>test_cookie=hello</code>（SameSite=None; Secure），并显示当前
          <code>document.cookie</code>。
        </p>
        <Button type="primary" onClick={this.handleTest}>
          展示cookie
        </Button>
        <br />
        <Button type="primary" onClick={this.deleteCookie}>
          删除cookie
        </Button>
        <br />
        <Button type="primary" onClick={this.toLive}>
          跳转直播页
        </Button>
        <br />
        <Button type="primary" onClick={this.login}>登录</Button>
        {this.state.result ? (
          <pre
            style={{
              marginTop: 16,
              padding: 12,
              background: '#f5f5f5',
              borderRadius: 4,
              fontSize: 13,
              wordBreak: 'break-word',
              maxWidth: '100%',
              // 文字强制折行
              whiteSpace: 'pre-wrap',
            }}
          >
            {this.state.result}
          </pre>
        ) : null}
      </div>
    );
  }
}
